import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConsoleService {

	public log(message?: any, ...optionalParams: any[]): void {
		console.log(message, optionalParams);
	}

	public warn(message?: any, ...optionalParams: any[]): void {
		console.warn(message, optionalParams);
	}

	public error(message?: any, ...optionalParams: any[]): void {
		console.error(message, optionalParams);
	}

  constructor(
	) { }
}
